import React, { createContext, useCallback, useContext, useRef, useState } from 'react';

const EntgeltEmbedContext = createContext(null);

export function EntgeltEmbedProvider({ children }) {
  const iframeRef = useRef(null);
  const [embedReady, setEmbedReady] = useState(false);
  /** Wie Original-App: Sidebar schmal während aktiver Bearbeitung (Chat, Phase ≠ ZUSAMMENFASSUNG). */
  const [embedSidebarCollapsed, setEmbedSidebarCollapsed] = useState(false);

  const setIframeEl = useCallback((el) => {
    iframeRef.current = el;
    if (!el) setEmbedReady(false);
  }, []);

  const postToEmbed = useCallback((msg) => {
    const w = iframeRef.current?.contentWindow;
    if (w) w.postMessage(msg, window.location.origin);
  }, []);

  const value = {
    iframeRef,
    setIframeEl,
    postToEmbed,
    embedReady,
    setEmbedReady,
    embedSidebarCollapsed,
    setEmbedSidebarCollapsed,
  };

  return <EntgeltEmbedContext.Provider value={value}>{children}</EntgeltEmbedContext.Provider>;
}

export function useEntgeltEmbed() {
  return useContext(EntgeltEmbedContext);
}
